// extracted by mini-css-extract-plugin
export default {"bioContainer":"Biodiversityen_bioContainer__ebKeM","bioText":"Biodiversityen_bioText__we77Y","bio":"Biodiversityen_bio__U1T36"};